import React from 'react';
import * as Sentry from '@sentry/react';

import './App.scss';

import { AppContainer } from '@nextroll/ar-container-app';

import telemetry from '@nextroll/telemetry';

import { SENTRY_INIT_CONFIG } from './util/services.sentry';
import { getEnvironment } from './util/urls';
import { WorkflowsApp } from './components/basic/WorkflowsApp';

const App = () => {
    const environment = getEnvironment();

    return (
        <AppContainer
            basePath=''
            environment={environment}
            applicationMap={{
                workflows: {
                    component: WorkflowsApp,
                    className: 'workflows',
                },
            }}
            initTrackingLibraries={() => {
                Sentry.init(SENTRY_INIT_CONFIG);
                telemetry.load({
                    appVersion: `rofl-ui-${process.env.VERSION}`,
                    env: environment,
                    heap: true,
                    segment: true,
                    userflow: true,
                });
            }}
            fetchTranslations={(): Promise<void> => {
                // return empty promise
                return Promise.resolve();
            }}
            disableRollWorksTheme
        />
    );
};

export default App;
